import { useMemo } from 'react';

export const useBannerHtml = (link: string, src: string, srcSet: string) =>
  useMemo(
    () => `<a href='${link}' style='display: block; width: 120px; height: 600px;'>
<img src='${src}' srcset='${srcSet}'>\n</a>`,
    [link, src, srcSet]
  );
